/**
 * Nome do Plano Master (template de todas as permissões)
 *
 * Este plano é criado automaticamente pelo Discovery e contém todas as permissões do sistema.
 * Funciona como um template/pool de permissões disponíveis.
 *
 * REGRAS:
 * - NUNCA deve ser deletado
 * - NUNCA deve ter suas permissões removidas
 * - Serve como base para criar outros planos
 */
export const MASTER_PLAN_NAME = 'MASTER';

/**
 * Período de trial do plano padrão (Experiência) em dias.
 * null = sem expiração (plano gratuito permanente)
 */
export const FREE_PLAN_TRIAL_DAYS: number | null = 30;

/** Nomes oficiais dos planos comerciais Bardo */
export const BARDO_PLAN_NAMES = {
  EXPERIENCIA: 'Experiência',
  ESMERALDA: 'Esmeralda',
  SAFIRA: 'Safira',
  DIAMANTE: 'Diamante',
} as const;
